import { render, staticRenderFns } from "./DoseEventEditor.vue?vue&type=template&id=b5ec057c&"
import script from "./DoseEventEditor.vue?vue&type=script&lang=js&"
export * from "./DoseEventEditor.vue?vue&type=script&lang=js&"
import style0 from "./DoseEventEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports